import { v4 } from 'uuid'

import { ItemDTO, ItemType } from 'src/models/dto/items/ItemDTO'
import { MediaElement } from 'src/models/dto/items/MediaDTO'
import { Locale, LocalizedAttribute, LocalizeDefault } from 'src/models/dto/Locale'

export interface ContentItemDTO extends ItemDTO, MediaElement {
    itemType: ItemType.Content
    textI18N: LocalizedAttribute<string>
    titleI18N?: LocalizedAttribute<string>
}

export const defaultContentItemDTO = (): ContentItemDTO => {
    const newId = v4()
    return {
        id: newId,
        itemType: ItemType.Content,
        label: '',
        locale: Locale.en_US,
        name: newId,
        optional: false,
        preserveOrder: false,
        ppt: ItemType.Content,
        textI18N: LocalizeDefault<string>(''),
        titleI18N: LocalizeDefault<string>(''),
    }
}
